import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadShipmentItemsModal = ({ onClose, fetchData, propData }) => {
  const [form, setForm] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [area_HQ, setArea_HQ] = useState("");
  const [state, setState] = useState("");
  const [olympiadTypes, setOlympiadTypes] = useState([]);
  const [olympiadType, setOlympiadType] = useState("");

  useEffect(() => {
    if (propData) {
      setName(propData.name || "");
      setOlympiadType(propData?.olympiad_type || "")

    }
  }, [propData]);
  console.log(propData, "propDatapropData");

  useEffect(() => {
    getAllOlympiadTypes()
  }, [])

  async function getAllOlympiadTypes() {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllOlympiadTypes();
      if (response?.status) {
        setOlympiadTypes(response?.data)
      }
      else {
        window.NotificationUtils.showError(response?.message || "Olympiad types dropdown response error")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  }



  const submitHandler = async () => {
    if (!olympiadType) {
      window.NotificationUtils.showError("Please Select Olympiad Type");
      return;
    }
    if (!name.trim()) {
      window.NotificationUtils.showError("Please fill in Item Name");
      return;
    }

    setLoading(true);
    // Ensure that the values are numbers
    try {
      if (propData) {
        await window.Platform.database.updateOlympiadShipmentItem({
          name: name,
          id: propData.id,
          olympiad_type: olympiadType
        });
        window.NotificationUtils.showSuccess("Shipment Item updated successfully");
      } else {
        await window.Platform.database.addOlympiadShipmentItem({ name, area_HQ: area_HQ, state: state, olympiad_type: olympiadType });
        window.NotificationUtils.showSuccess("Shipment Item saved successfully");
      }
      setName("");
      fetchData();
      onClose();
    } catch (err) {
      window.NotificationUtils.showError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">
            {propData ? "Update Shipment Item" : "Add Shipment Item"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>

        {loading && <OpaqueLoading />}

        <Stack gap={2} padding={2}>
          <FormControl size="small" fullWidth>
            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Olympiad Type</InputLabel>
            <Select
              value={olympiadType}
              label="Select Olympiad Type"
              size="small"
              onChange={(e) => { setOlympiadType(e.target.value) }}
            >
              {olympiadTypes.map((type) => (
                <MenuItem key={type} value={type.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{type.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>

            <TextField
              label="Shipment Item Name"
              value={name || ''}
              type="text"
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />
          </FormControl>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

            <Button
              color="primary"
              variant="contained"
              onClick={submitHandler}
              disabled={!name}
            >
              {propData ? 'Update' : 'Create'}
            </Button>
          </div>
        </Stack>
      </StyledDialogContent>

    </Dialog>
  );
};

export default OlympiadShipmentItemsModal;
